import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AccountAppPage = Loadable(lazy(() => import("./AccountAppPage")));
const MyApps = Loadable(lazy(() => import("./MyApps")));
const InstallPage = Loadable(lazy(() => import("./InstallPage")));
const UninstallPage = Loadable(lazy(() => import("./UninstallPage")));
const InstallResultPage = Loadable(lazy(() => import("./InstallResultPage")));
const AccountAppResourcesPage = Loadable(lazy(() => import("./AccountAppResourcesPage")));
const AppFormPage = Loadable(lazy(() => import("./AppFormPage")));

const myAppsRoutes = [
  { path: "account-app/:id", element: <AccountAppPage /> },
  { path: "account-apps", element: <MyApps /> },
  { path: "account-apps/:id/install", element: <InstallPage /> },
  { path: "account-apps/:id/install-result", element: <InstallResultPage /> },
  { path: "account-apps/:id/resources", element: <AccountAppResourcesPage /> },
  { path: "account-apps/:id/uninstall", element: <UninstallPage /> },
  { path: "account-apps/:id", element: <AppFormPage /> },
];

export default myAppsRoutes;
